module.exports = __webpack_public_path__ + "img/like-disabled-big.351a1416.svg";